module.exports = __webpack_public_path__ + "static/img/exterior.413b9b2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/exterior.jpg
// module id = fbGH
// module chunks = 0